import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _TimeEventAccounting, _TimeEventCatalog, _TimeEventPending } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../../theme/Input/InputDate";
import { SelectStoreEditor } from "../../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import useModal, { MODAL_LG } from "../../../../theme/Component/hooks/useModal";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import usePaginator from "../../../../theme/Component/usePaginator";




export const TimeEventPending = () => {

    const TimeEventPending = useDataBean(_TimeEventPending);
    const CreateTimemov = useDataBean(_TimeEventAccounting);
    const single = Singleton.getInstance();
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(null)
    const [docs, setDocs] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const paginador = usePaginator();
    const [form, setForm] = useState<any>({

        Year: _single.getCurrenYear(),
        Month: NaN,
        AccountantDate: NaN,

    })
    const [reporte, setDescargarreporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [formato, setFormato] = useState<any>([]);
    const [modalcreate, setModalcreate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcontabletime, setModalcontabletime] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdoc, setModalverdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalverdocvdos, setModalverdocvdos] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modaldoccreate = useModal("Contabilizar Tiempos y Movimientos", MODAL_LG);
    useEffect(() => {
        getLista()
    }, [paginador.page]);
    useEffect(() => {
        if (modalverdoc.view) {
            verDocumentos();
        }
    }, [modalverdoc.view]);
    const getLista = () => {

        TimeEventPending.instance.getTimeEventPendingForAccounting(year, month, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    let x = resp.List;
                    x.forEach((user) => {

                        user.DataBeanProperties.Doc = (user.DataBeanProperties.Mnemonic ?? "") + "-" + (user.DataBeanProperties.Consecutive ?? "") + "-" + (user.DataBeanProperties.DocumentDate ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }


    const create = () => {
        TimeEventPending.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const verbytime = () => {

        setModalcreate({ ...modalcreate, "view": true });
    }
    const deleteItem = () => {
        TimeEventPending.deleteItemVoid(TimeEventPending.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        TimeEventPending.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTimeEvent', visible: true },
        { title: 'ID Orden de Produccion', property: 'IDProductionOrder', visible: true },
        { title: 'Fecha Orden de Producción', property: 'ProductionOrderDate', visible: true },
        { title: 'Actividad/Operación', property: 'LabourName', visible: true },
        { title: 'Cantidad Producida', property: 'LabourQuantity', visible: true },
        { title: 'Cantidad Tiempo', property: 'TimeUnits', visible: true },
        { title: 'Unidades Medida', property: 'LabourTimeUnitName', visible: true },
        { title: 'Empleado en Línea de Producción', property: 'ProductionEmployeeName', visible: true },
        { title: 'Turno', property: 'IDWorkTurn', visible: true },
        { title: 'Fecha Turno', property: 'WorkTurnDate', visible: true },
        { title: 'Documento', property: 'Doc', visible: true },
    ]
    const verDocumentos = () => {

        if (TimeEventPending.bean) {
            _documentos.instance.getPdfAccountantDocument(TimeEventPending.bean.IDDocument, null, TimeEventPending.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModalverdoc({ ...modalverdoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalverdoc({ ...modalverdoc, "view": true }) } },
            { titulo: 'Contabilizar Tiempos y Movimientos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalcontabletime({ ...modalcontabletime, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createTimeEventAccountingForProductionOrder = () => {
        CreateTimemov.instance.createTimeEventAccountingForProductionOrder(TimeEventPending.bean.IDTimeEvent, CreateTimemov.bean.AccountantDate, CreateTimemov.bean.Description, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Contabilizado')
                    setDocsvdos(resp.DocumentURL);
                    setModalcontabletime({ ...modalcontabletime, "view": false });
                    setModalverdocvdos({ ...modalverdocvdos, "view": true });
                    setMsgList(resp.MsgList);

                    // ✅ Mostrar cada mensaje del backend en un toast
                    resp.MsgList?.forEach((msg: string) => {
                        toast.info(msg);
                    });
                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const createTimeEventAccountingForProductionOrdervdos = () => {
        CreateTimemov.instance.createTimeEventAccountingForProductionOrdervdos(form.Year, form.Month, form.AccountantDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    toast.success('Contabilizado')
                    setFormato(resp[0]);
                    setModalcreate({ ...modalcreate, "view": false });
                    setDescargarreporte({ ...reporte, "view": true });

                }
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <BasicPage titulo="Valoración Masiva de Trabajo en Proceso">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthConstantsEditor idSelect={month} onChange={(e) => { setmonth(e) }} label="Mes" name="" />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-4">

                    <BasicButton icon="ri-profile-line" clase="btn btn-outline-primary btn-border" eventClick={verbytime}>
                        Contabilizar Tiempos y Movimientos
                    </BasicButton>

                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={TimeEventPending.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                    <Modal modal={modalverdoc} updateModal={setModalverdoc}>
                        <div className="row">

                            <DocumentViewer
                                list={docs}
                                IDDocument={TimeEventPending.bean.IDDocument}
                                Since={TimeEventPending.bean.DocumentDate}
                            />
                        </div>
                    </Modal>

                    <Modal modal={modalcontabletime} updateModal={setModalcontabletime} eventModal={createTimeEventAccountingForProductionOrder} onSubmitLabel="Contabilizar">
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="AccountantDate" value={CreateTimemov.bean.AccountantDate} label="Fecha de Contabilización" setDate={(e) => { CreateTimemov.setBean({ ...CreateTimemov.bean, "AccountantDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={CreateTimemov.bean.Description} onChange={(e) => { CreateTimemov.setBean({ ...CreateTimemov.bean, 'Description': e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalverdocvdos} updateModal={setModalverdocvdos}>
                        <div className="row">
                            <PrintJson json={msgList} />
                            <DocumentViewer
                                list={docsvdos}
                            />
                        </div>
                    </Modal>
                    <Modal modal={modalcreate} updateModal={setModalcreate} eventModal={createTimeEventAccountingForProductionOrdervdos}>
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={form.Year} tittle="Año" onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor idSelect={form.Month} onChange={(e) => { setForm({ ...form, "Month": e }) }} label="Mes" name="" />
                            </div>
                            <div className="col-md-12">
                                <InputDate name="AccountantDate" value={form.AccountantDate} label="Fecha de Contabilización" setDate={(e) => { setForm({ ...form, "AccountantDate": e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={reporte} updateModal={setDescargarreporte}>
                        <div className="row">
                            {formato?.DataBeanProperties?.URLLink && (
                                // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                            <strong> 📄 {formato.DataBeanProperties.Filename}</strong>
                                        </a>
                                    </div>
                                </div>

                            )}



                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {TimeEventPending.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}